import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import authReducer from './authReducer';
import errorsReducer from './errorsReducer';
import settingsReducer from './settingsReducer';
import mainMarketsReducer from './mainMarketsReducer';
import marketDescriptionsReducer from './marketDescriptionsReducer';
import sportEventsReducer from './sportEventsReducer';
import sportTypesReducer from './sportTypesReducer';
import allMarketsReducer from './allMarketsReducer';
import betSlipReducer from './betSlipReducer';
import eventDetailReducer from './eventDetailReducer';
import ticketsReducer from './ticketsReducer';
import timerReducer from './timerReducer';
import eventResultsReducer from './eventResultsReducer';
import seasonsReducer from './seasonsReducer';
import socketReducer from './socketReducer';
import feed from './feed';
import global from './global';
import modals from './modals';
import translationsReducer from './translationsReducer';
import outrights from './outrightsReducer';

const betSlipPersistConfig = {
    key: 'betslip',
    storage,
    blacklist: [
        'isFetchingEvents',
        'isTicketSubmitting',
        'placedTicketDetails',
        'validations',
        'placedBetErrors',
        'selectedCombinations',
        'stakeLimits',
    ],
    stateReconciler: autoMergeLevel2,
};

const descriptionConfig = {
    key: 'descriptions',
    storage,
};

const settingsPersistConfig = {
    key: 'settings',
    storage: storageSession,
    whitelist: ['translationMode'],
    stateReconciler: autoMergeLevel2,
};

const translationsPersistConfig = {
    key: 'translations',
    storage,
    whitelist: ['list'],
    stateReconciler: autoMergeLevel2,
};

const appReducer = combineReducers({
    auth: authReducer,
    error: errorsReducer,
    settings: persistReducer(settingsPersistConfig, settingsReducer),
    global,
    mainMarkets: mainMarketsReducer,
    sportEvents: sportEventsReducer,
    sportTypes: sportTypesReducer,
    allMarkets: allMarketsReducer,
    eventDetails: eventDetailReducer,
    tickets: ticketsReducer,
    timer: timerReducer,
    results: eventResultsReducer,
    seasons: seasonsReducer,
    socket: socketReducer,
    betSlip: persistReducer(betSlipPersistConfig, betSlipReducer),
    descriptions: persistReducer(descriptionConfig, marketDescriptionsReducer),
    feed,
    modals,
    translations: persistReducer(translationsPersistConfig, translationsReducer),
    outrights,
});

export default function rootReducer(state, action) {
    if (action.type === 'LOGOUT_USER_SUCCESS') {
        state = undefined;
    }

    return appReducer(state, action);
}
